"use client";

import type * as React from "react";
import { Toaster as Sonner, type ToasterProps } from "sonner";

interface ToasterWithThemeProps extends Omit<ToasterProps, "theme"> {
	theme?: "light" | "dark" | "system";
}

const Toaster = ({ theme = "system", ...props }: ToasterWithThemeProps) => (
	<Sonner
		className="toaster group"
		style={
			{
				"--normal-bg": "var(--popover)",
				"--normal-text": "var(--popover-foreground)",
				"--normal-border": "var(--border)",
			} as React.CSSProperties
		}
		theme={theme}
		{...props}
	/>
);

export { Toaster };
